import React from 'react';
import { Smartphone, Download, Apple, Play } from 'lucide-react';
import { useLang } from '../core/lang';
import LangKeys from '../core/locales/keys';

const MobileRestriction = () => {
  return (
    <div style={styles.container}>
      <div style={styles.content}>
        {/* LOGO SECTION */}
        <div style={styles.brandSection}>
          <div style={styles.logoBox}>
            <img src="/logo.png" alt="Moxpal Khata" style={styles.mainLogo} />
          </div>
          <div style={styles.brandText}>
            <h2 style={styles.brandName}>Moxpal Khata</h2>
            <span style={styles.tagline}>Simple. Paperless. Secure.</span>
          </div>
        </div>
        
        {/* HERO IMAGE/ILLUSTRATION */}
        <div style={styles.heroSection}>
          <div style={styles.deviceIcon}>
            <Smartphone size={60} strokeWidth={1} color="#64748B" />
          </div>
        </div>

        {/* MESSAGE SECTION */}
        <div style={styles.messageSection}>
          <h1 style={styles.title}>
            Moxpal Khata on mobile is available for Android and iOS users.
          </h1>
          <p style={styles.subtitle}>
            Download our app for the best experience on your smartphone.
          </p>
        </div>

        {/* STORE BUTTONS */}
        <div style={styles.buttonGroup}>
          <a
            href="https://play.google.com/store/apps/details?id=com.moxpal.khata.moxpal_khata_market"
            target="_blank"
            rel="noopener noreferrer"
            style={styles.storeButton}
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
              alt="Get it on Google Play"
              style={styles.storeBadge}
            />
          </a>

          <a
            href="https://apps.apple.com/app/moxpal-khata"
            target="_blank"
            rel="noopener noreferrer"
            style={styles.storeButton}
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg"
              alt="Download on the App Store"
              style={styles.storeBadge}
            />
          </a>
        </div>

        {/* FOOTER */}
        <div style={styles.footer}>
          <p style={styles.copyright}>Copyright © {new Date().getFullYear()} Moxpal Technology. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    width: '100vw',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#FFFFFF',
    padding: '24px 16px',
    textAlign: 'center',
    fontFamily: "'Outfit', sans-serif",
    boxSizing: 'border-box',
    overflowY: 'auto'
  },
  content: {
    width: '100%',
    maxWidth: '380px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0px'
  },
  brandSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    marginBottom: '40px',
    width: '100%',
    justifyContent: 'center'
  },
  logoBox: {
    width: '50px',
    height: '50px',
    borderRadius: '12px',
    overflow: 'hidden',
    boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
  },
  mainLogo: {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  },
  brandText: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  brandName: {
    fontSize: '20px',
    fontWeight: '800',
    color: '#0F172A',
    margin: 0,
    letterSpacing: '-0.5px'
  },
  tagline: {
    fontSize: '12px',
    color: '#64748B',
    fontWeight: '500'
  },
  heroSection: {
    marginBottom: '32px',
    opacity: 0.6
  },
  deviceIcon: {
    padding: '30px',
    background: '#F8FAFC',
    borderRadius: '30px'
  },
  messageSection: {
    marginBottom: '40px'
  },
  title: {
    fontSize: '22px',
    fontWeight: '800',
    color: '#1E293B',
    lineHeight: '1.4',
    marginBottom: '12px'
  },
  subtitle: {
    fontSize: '15px',
    color: '#64748B',
    lineHeight: '1.6',
    fontWeight: '500',
    padding: '0 10px'
  },
  buttonGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    width: '100%',
    alignItems: 'center'
  },
  storeButton: {
    transition: 'transform 0.2s cubic-bezier(0.34, 1.56, 0.64, 1)',
    cursor: 'pointer',
    display: 'flex',
    maxWidth: '200px'
  },
  storeBadge: {
    width: '100%',
    height: 'auto'
  },
  footer: {
    marginTop: '40px'
  },
  copyright: {
    fontSize: '12px',
    color: '#94A3B8',
    fontWeight: '500'
  }
};

export default MobileRestriction;
